import { render, staticRenderFns } from "./DefaultFour.vue?vue&type=template&id=2247ba00&scoped=true&"
import script from "./DefaultFour.vue?vue&type=script&lang=js&"
export * from "./DefaultFour.vue?vue&type=script&lang=js&"
import style0 from "./DefaultFour.vue?vue&type=style&index=0&id=2247ba00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2247ba00",
  null
  
)

export default component.exports